import { render, staticRenderFns } from "./PoljeUnosaBroj.vue?vue&type=template&id=5be3e70f&scoped=true&"
import script from "./PoljeUnosaBroj.vue?vue&type=script&lang=js&"
export * from "./PoljeUnosaBroj.vue?vue&type=script&lang=js&"
import style0 from "./PoljeUnosaBroj.vue?vue&type=style&index=0&id=5be3e70f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be3e70f",
  null
  
)

export default component.exports